import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { addDays, subYears } from "date-fns";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { useDispatch, useSelector } from "react-redux";
import { storeFiltersValue } from "../../../../redux/actions/TicketsManagement/GetTickets";
import { IState } from "../../../../redux/reducers/rootReducers";
import CommonStyles from "../../../common/CommonStyles";
import CommonPopover from "../../../common/popover/CommonPopover";
const CalendarRangeOptionCSV = () => {
  const dispatch = useDispatch();
  const cstyles = CommonStyles();
  const classes = useStyles();
  const FiltersVal: any = useSelector(
    (state: IState) => state?.filtersTicketManagementReducerForCSV?.rangeVal
  );
  const [DaysList] = useState(["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [dateRangeFilterVal, setdateRangeFilterVal] = useState("OpenDateTime");

  const [rangeState, setRangeState] = useState<any>([
    {
      startDate: subYears(new Date(), 1),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (FiltersVal) {
      setRangeState([
        {
          startDate: new Date(FiltersVal?.startDate),
          endDate: new Date(FiltersVal?.endDate),
          key: "selection",
          node: FiltersVal?.node,
        },
      ]);
      setdateRangeFilterVal(FiltersVal.node || "OpenDateTime");
    } else {
      setRangeState([
        {
          startDate: subYears(new Date(), 1),
          endDate: addDays(new Date(), 0),
          key: "selection",
        },
      ]);
    }
  }, [FiltersVal]);

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOnChange = (ranges: any) => {
    const { selection } = ranges;
//     console.log('handleOnChange', selection)
    if(selection){
      setRangeState([selection]);
    }
   
  };
  const applyDate = () => {
    handleCloseRangePicker();
    dispatch(
      storeFiltersValue(
        {...rangeState[0], node: dateRangeFilterVal },
        "TCKT_RANGE_VALUE_CSV"
      )
    );
  };
  const filterDateTypeChange = (e: any) => {
//     console.log("filterDateTypeChange", e.target.value);
    setdateRangeFilterVal(e?.target?.value);
  };
  const handleCloseRangePicker = () => {
    setAnchorEl(null);
  };
  const selectDateRange = (e: any) => {
    setAnchorEl(e?.target);
  };
  return (
    <Box>
      <div
        className={[
          classes.title,
          cstyles.themeColorTxt,
          classes.titleDate,
        ].join(" ")}
      >
        <span onClick={(e: any) => selectDateRange(e)}>
          From <b>{moment(rangeState?.[0]?.["startDate"])?.format("L")} </b> (
          {DaysList[rangeState?.[0]?.["startDate"]?.getDay()]}) to{" "}
          <b> {moment(rangeState?.[0]?.["endDate"])?.format("L")}</b> (
          {DaysList[rangeState?.[0]?.["endDate"]?.getDay()]}){"("}
         {FiltersVal?.key}
          {")"}
        </span>

        <DateRangeOutlinedIcon
          onClick={(e: any) => selectDateRange(e)}
          className={`${classes.icon}`}
        />
      </div>
      <CommonPopover
        id="filterPopoverDateRange"
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        bodyContent={
          <>
            <Box>
              <Box className={classes.dateInnerContainer}>
                <DateRangePicker
                  onChange={handleOnChange}
                  //showSelectionPreview={true}
                  moveRangeOnFirstSelection={true}
                  months={2}
                  ranges={rangeState}
                  direction="horizontal"
                />
              </Box>
              <Box className={`${classes.dateRangeActionButtons} calender-popup-filter`}>
                <Box>
                  <Typography
                    variant="caption"
                    className=""
                    display="block"
                  ></Typography>
                  <FormControl>
                    <FormLabel id="choose-date-range-type">
                      Filter based on : 
                      {/* {dateRangeFilterVal} */}
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="choose-date-range-type"
                      name="date-range-buttons-group"
                      onChange={filterDateTypeChange}
                      value={dateRangeFilterVal}
                      defaultValue={"OpenDateTime"}
                      className="date-range-calender-radio"
                    >
                      <FormControlLabel
                        value="OpenDateTime"
                        control={<Radio />}
                        label="Opened Date"
                      />
                      <FormControlLabel
                        value="DueDateTime"
                        control={<Radio />}
                        label="Due Date"
                      />
                      <FormControlLabel
                        value="FirstResponseDueDateTime"
                        control={<Radio />}
                        label="First action date"
                      />
                      <FormControlLabel
                        value="CreatedDateTime"
                        control={<Radio />}
                        label="Updated date"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                <Box>
                  <Button variant="outlined" onClick={handleCloseRangePicker}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.applyButton}
                    onClick={applyDate}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Box>
          </>
        }
      />
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  dateInnerContainer: {
    display: "flex",
  },
  dateRangeActionButtons: {
    borderTop: "1px solid #ddd",
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    "& span": {
      lineHeight: 1,
      fontSize: "11px",
    },
  },
  applyButton: {
    backgroundColor: "#007bff",
    marginLeft: "9px",
    color: "white",
    "& span": {
      lineHeight: 1,
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
  },
  titleDate: {
    fontSize: 10,
  },
  icon: {
    width: 18,
    height: 18,
  },
}));
export default CalendarRangeOptionCSV;
